// Shared constants for the Time Billing feature so the project-scoped form,
// the Reports "+ Log Time" modal, and the self-service timesheet don't each
// redefine (and risk drifting on) the sentinel used for non-project time.
export const INTERNAL_PROJECT_ID = 'internal';

export const DEFAULT_TIME_CATEGORIES = ['Internal', 'Admin', 'Business Development', 'PTO'];

// Time Billing invoices store line items grouped by activity. The "list"
// layout shows the same items in one table with an Activity column instead.
export function isTBInvoiceListLayout(invoice) {
  return invoice?.display?.layout === 'list';
}

// Sections to render for an invoice: its activity groups as-is, or (list
// layout) a single heading-less section whose items each carry their activity.
export function getTBInvoiceSections(invoice) {
  const groups = invoice?.groups || [];
  if (!isTBInvoiceListLayout(invoice)) return groups;

  const items = groups.flatMap((group) =>
    (group.items || []).map((item) => ({ ...item, activity: item.activity || group.heading || '' }))
  );
  return items.length ? [{ heading: '', items }] : [];
}
